<template>
	<div class="content-wrapper" style="margin-bottom:300px">
		<!-- <app-breadcrumb :page-title="`Parent Interview Form - ${this.basicInfoPropsData?.clc_id_number}`" /> -->
	<app-breadcrumb
  :page-title="`Parent Interview Form - <a href='/transaction/profile-lead/${basicInfoPropsData?.id}' class='text-primary' style='text-decoration:underline;'>${basicInfoPropsData?.lead_id_number}</a>`"
  v-if="basicInfoPropsData"
  v-html="pageTitle"
/>




		<!-- <app-breadcrumb
			:page-title="`Parent Interview Form - <a href='/transaction/profile-lead/${basicInfoPropsData?.id}' style='color:black;'>${basicInfoPropsData?.lead_id_number}</a>`"
			v-if="basicInfoPropsData"
			v-html="pageTitle"
		/> -->
		<div
			class="card p-primary border-0"
			v-if="
				basicInfoPropsData || 
				languagePropsData ||
				schoolPropsData ||
				consentPropsData
			"
		>
			<parent-interview-form-wizard :tabs="computedTabs" />
		</div>
	</div>
</template>

<script>
const ParentInterviewBasicInfo = () => import('./Tabs/BasicInfo/BasicInfo.vue')
// const ParentInterviewSchool = () => import('./Tabs/School/School.vue')
// const ParentInterviewLanguage = () => import('./Tabs/Language/Language.vue')
// const ParentInterviewConsent = () => import('./Tabs/Consent/Consent.vue')
const ParentInterviewTabs = () => import('./Tabs/ParentInterview/ParentInterview.vue')
const ParentInterviewBooking = () => import('./Tabs/Booking/Booking.vue')

export default {
	name: "parentInterviewForm",
	data() {
		return {
			id: null,
			basicInfoPropsData: null,
			languagePropsData: null,
			schoolPropsData: null,
			consentPropsData: null,
			bookingPropsData: null,
			parentInterviewPropsData: null,
			tabs: [
				{
					name: "lead info",
					component: ParentInterviewBasicInfo
				},
				{
					name: "parent interview",
					component: ParentInterviewTabs
				},
				// {
				// 	name: "language",
				// 	component: ParentInterviewLanguage
				// },
				// {
				// 	name: "school",
				// 	component: ParentInterviewSchool
				// },
				// {
				// 	name: "consent",
				// 	component: ParentInterviewConsent
				// },
				{
					name: "booking",
					component: ParentInterviewBooking
				},
			],
		};
	},
	created() {
		let url = window.location.href;
		this.id = url.split("/").slice(-1)[0].split("?")[0];
		this.fetchData();
	},
	computed: {
		  pageTitle() {
			return `<h4>Parent Interview Form${this.basicInfoPropsData?.lead_id_number ? 
			` - <a href='/transaction/profile-lead/${this.basicInfoPropsData.id}' class='text-primary' style='text-decoration:underline;'>${this.basicInfoPropsData.lead_id_number}</a></h4>` 
			: ''}`;
		},
		computedTabs() {
			return this.tabs.map((tab) => {
				if (tab.name === "lead info") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.basicInfoPropsData,
						},
					};
				}
				if (tab.name === "parent interview") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.parentInterviewPropsData,
						},
					};
				}
				// if (tab.name === "language") {
				// 	return {
				// 		...tab,
				// 		props: {
				// 			...tab.props,
				// 			value: this.languagePropsData,
				// 		},
				// 	};
				// }
				// if (tab.name === "school") {
				// 	return {
				// 		...tab,
				// 		props: {
				// 			...tab.props,
				// 			value: this.schoolPropsData,
				// 		},
				// 	};
				// }
				// if (tab.name === "consent") {
				// 	return {
				// 		...tab,
				// 		props: {
				// 			...tab.props,
				// 			value: this.consentPropsData,
				// 		},
				// 	};
				// }
				if (tab.name === "booking") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.bookingPropsData,
						},
					};
				}
				return tab;
			});
		},
	},
	methods: {
		async fetchData() {
			try {
				const userResponse = await axios.get(
					"/transaction/lead/" + this.id
				);
				// console.log(userResponse.data);

				// Check if this.basicInfoPropsData is null and initialize it as an empty object if needed
				if (!this.basicInfoPropsData) {
					this.basicInfoPropsData = {};
				}
				// Assign other data to basicInfoPropsData
				this.basicInfoPropsData = userResponse.data;

				// assign data to schoolPropsData
				// this.schoolPropsData = userResponse.data;

				// // assign data to languagePropsData
				// this.languagePropsData = userResponse.data;

				// // assign data to consentPropsData
				// this.consentPropsData = userResponse.data;
				
				this.parentInterviewPropsData = userResponse.data;

				// assign data to bookingPropsData
				this.bookingPropsData = userResponse.data;
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
	},
};
</script>

<style scoped>
.card {
	box-shadow: 0 18px 20px rgba(0, 0, 0, 0.2); /* You can adjust the values to control the shadow effect */
}
</style>
